var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { RoutePath, ShopTab, generateRoutePath } from '../../app/router/config';
import Header from '../../components/shop/header';
import SerieListItem from '../../components/shop/serie-list-item';
import { ExternalTranslationsContext } from '../../context/external-translations';
import { appEnv } from '../../env';
import { useCtaTokenRates } from '../../hooks/cta-token/use-cta-token-rates';
import { useShop } from '../../hooks/shop/use-shop';
import Layout from '../../layout';
import { getKeyFromEnum } from '../../utils/common';
export default function Shop() {
    var t = useI18n().t;
    var tab = useParams().tab;
    var _a = useContext(ExternalTranslationsContext), externalTranslations = _a.externalTranslations, initialize = _a.initialize;
    var ctaTokenUsdRate = useCtaTokenRates().ctaTokenUsdRate;
    var _b = useShop(), series = _b.series, perks = _b.perks;
    useEffect(function () {
        if (!externalTranslations) {
            initialize();
        }
    }, [externalTranslations, initialize]);
    var tabs = [
        {
            label: t('shop.tab.cards'),
            path: generateRoutePath(RoutePath.SHOP, { tab: ShopTab.CARDS }),
            selected: tab === ShopTab.CARDS,
        },
        {
            label: t('shop.tab.lands'),
            path: generateRoutePath(RoutePath.SHOP, { tab: ShopTab.LANDS }),
            selected: tab === ShopTab.LANDS,
            disabled: true,
        },
    ];
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { ctaTokenUsdRate: ctaTokenUsdRate, tabs: tabs, vip: perks ? { level: perks.loyaltyLevel, discount: perks.perks.global.shopDiscount } : undefined }), _jsx(Container, { children: tab === ShopTab.CARDS && (_jsx(SeriesContainer, { children: externalTranslations &&
                            series &&
                            __spreadArray([], series, true).map(function (serie) { return (_jsx(SerieListItem, { daysRemaining: Math.floor(moment(serie.endDateAvailability).diff(moment(), 'days')), description: externalTranslations["shop/serie/".concat(getKeyFromEnum(serie.serie), "/description")], id: serie.serie, imageUrl: "".concat(appEnv.marketplaceImagesUrl.shop, "banner/shop-banner-").concat(getKeyFromEnum(serie.serie), ".png"), name: externalTranslations["shop/serie/".concat(getKeyFromEnum(serie.serie), "/name")] }, serie.serie)); }) })) })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var SeriesContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 32px;\n  justify-content: flex-start;\n  padding: 40px 0;\n  width: 1072px;\n\n  @media screen and (max-width: 1200px) {\n    width: 800px;\n  }\n\n  @media screen and (max-width: 840px) {\n    justify-content: center;\n    gap: 16px;\n    width: 640px;\n  }\n\n  @media screen and (max-width: 824px) {\n    gap: 32px;\n    padding: 40px 16px;\n    width: 100%;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 32px;\n  justify-content: flex-start;\n  padding: 40px 0;\n  width: 1072px;\n\n  @media screen and (max-width: 1200px) {\n    width: 800px;\n  }\n\n  @media screen and (max-width: 840px) {\n    justify-content: center;\n    gap: 16px;\n    width: 640px;\n  }\n\n  @media screen and (max-width: 824px) {\n    gap: 32px;\n    padding: 40px 16px;\n    width: 100%;\n  }\n"])));
var templateObject_1, templateObject_2;
